import BaseComponent from "@js/components/base_component.jsx";

import MuiAlertsForm from "@js/components/mui/alerts/form.jsx";

class MuiAlertsShow extends BaseComponent {

  render() {
    return (
      <MuiAlertsForm { ...this.props } editing={ false } />
    );
  }

}

export default MuiAlertsShow;
